import gql from 'graphql-tag';
import { useLazyQuery } from '@vue/apollo-composable';
import { reactive } from 'vue';

const ContractorQuery = gql`
  query ContractorCompanies($searchAll: Boolean!) {
    contractorCompanies(searchAll: $searchAll) {
      CERTIFIEDCONTRACTOR
      LAT
      LNG
      COMPANYID
      NAME
      address {
        CITY
        LINE1
        LINE2
        POSTALCODE
        STATE
      }
      phones {
        NUMBERDISPLAY
        TYPEID
        EXT
      }
      contacts {
        CONTACTID
        email {
          ADDRESS
        }
        SALESCONTACT
        INACTIVE
      }
    }
  }
`;

function useContractorQuery() {
  const variables = reactive({
    searchAll: false,
  });
  const { load, refetch } = useLazyQuery(ContractorQuery, variables);
  return { load, refetch };
}

export default useContractorQuery;
